import React, { FC } from 'react';
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const ExplorerIcon: FC<SvgIconProps> = (props) => (
	<SvgIcon {...props} viewBox="0 0 20 20">
		<path d="M2.29183 15.2916C2.11127 15.1111 2.021 14.9028 2.021 14.6666C2.021 14.4305 2.11127 14.2222 2.29183 14.0416L6.72933 9.60415C7.04877 9.2847 7.44461 9.12498 7.91683 9.12498C8.38905 9.12498 8.78488 9.2847 9.10433 9.60415L11.2502 11.75L16.5835 5.72915C16.7363 5.54859 16.9342 5.45831 17.1772 5.45831C17.4203 5.45831 17.6252 5.54165 17.7918 5.70831C17.9446 5.86109 18.0245 6.04512 18.0314 6.2604C18.0384 6.47567 17.9654 6.66665 17.8127 6.83331L12.4168 12.9166C12.0974 13.2778 11.7016 13.4687 11.2293 13.4896C10.7571 13.5104 10.3474 13.3472 10.0002 13L7.91683 10.9166L3.54183 15.2916C3.36127 15.4722 3.15294 15.5625 2.91683 15.5625C2.68072 15.5625 2.47238 15.4722 2.29183 15.2916Z" />
	</SvgIcon>
)

export default ExplorerIcon;
